import { t } from '@lingui/macro';
import { useAmplitude } from 'hooks/useAmplitude';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from '../Navigation.module.css';
import { NavItemLink } from '../NavItemLink/NavItemLink';

export const FAQsButton = () => {
  const { trackEvent } = useAmplitude();

  const handleFAQsClickTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.internalLinkClicked, {
      'CTA destination': 'FAQs',
      'CTA text': 'FAQs',
      'CTA URL': PATH_NAMES.faqs(),
    });
  };

  return (
    <NavItemLink
      className={styles.navItemInner}
      href={PATH_NAMES.faqs()}
      onClick={handleFAQsClickTracking}
      label={t`FAQs`}
      data-testid="faqs-link"
    />
  );
};
